import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { SwiperComponent } from '@x/common/swiper/swiper.component';
import { TAssociationOrigin } from '@x/common/tracking';
import { TAddToCartOrigin } from '@x/ecommerce-shop/app/core/order/services/add-to-cart.service';
import { PRODUCT_SWIPER_OPTIONS } from '@x/ecommerce-shop/app/core/product/components/product-swiper-slider/swiper';
import { IShopProductItem } from '@x/ecommerce/shop-client';
import { Swiper } from 'swiper/types';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'x-product-swiper-slider',
  templateUrl: './product-swiper-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-product-swiper-slider' },
})
export class ProductSwiperSliderComponent {
  private _swiperOptions: SwiperOptions = PRODUCT_SWIPER_OPTIONS;
  @Input() set swiperOptions(options: SwiperOptions) {
    this._swiperOptions = { ...this.swiperOptions, ...options };
  }
  get swiperOptions() {
    return this._swiperOptions;
  }

  @Output() onSlideChange = new EventEmitter<Swiper>();
  @Output() onActiveIndexChange = new EventEmitter<Swiper>();
  @Output() onReachEnd = new EventEmitter<Swiper>();
  @Output() onNextClickEvent = new EventEmitter<Swiper>();

  @Input() products: IShopProductItem[] = [];
  @Input() associationId?: number;
  @Input() associationOrigin?: TAssociationOrigin;
  @Input() origin?: TAddToCartOrigin | TAssociationOrigin;
  @Input() taxonId?: number;
  @Input() loading: Boolean | null = false;
  @Input() listName?: string;

  @ViewChild('SWIPER_COMPONENT') swiperComponent: SwiperComponent<IShopProductItem>;
  get swiper() {
    return this.swiperComponent.swiper;
  }

  private moreProductsIndex = 0;
  moreProductsByIndex: Record<number, IShopProductItem[]> = {};

  @Input() set moreProducts(moreProducts: IShopProductItem[] | null | undefined) {
    if (!moreProducts?.length) return;

    this.moreProductsIndex++;
    this.moreProductsByIndex[this.moreProductsIndex] = moreProducts;
  }

  @ViewChildren('MORE_SLIDE_GROUPS') set moreSlides(slides: QueryList<ElementRef<HTMLDivElement>>) {
    const slidesArr = slides.toArray();
    if (!slidesArr.length) return;

    const group = slidesArr.find(
      (el) => el.nativeElement.id === `group-index-${this.moreProductsIndex}`,
    );
    if (!group) return;

    const slidesElements = Array.from(group.nativeElement.children) as HTMLElement[];
    this.swiper?.appendSlide(slidesElements);
    this.swiper?.update();
  }
}
